import {
  CONFIGURATION_SETTING_ERROR,
  GET_CONFIGURATION_SETTING_DETAIL,
  GET_PRIVACY_POLICY,
  UPDATE_PRIVACY_POLICY,
  UPDATE_SETTING_DETAIL,
} from "reduxStore/types";

const initialState = {
  response: {},
  loading: true,
  create: false,
  detail: false,
};

export default function configurationSettingReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_CONFIGURATION_SETTING_DETAIL:
      return {
        ...state,
        create: false,
        detail: true,
        response: action.payload,
      };
    case UPDATE_SETTING_DETAIL:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
    case CONFIGURATION_SETTING_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    case GET_PRIVACY_POLICY:
      return {
        ...state,
        detail: true,
        create: false,
        result: action.payload,
      };
    case UPDATE_PRIVACY_POLICY:
      return {
        ...state,
        detail: false,
        create: true,
        result: action.payload,
      };

    default:
      return state;
  }
}
